module.exports = __webpack_public_path__ + "static/Montserrat-Bold-d14ad1035ae6da4e5a71eca362a8d696.ttf";